var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_13",
    "data-name": 13,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 568 546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #010b6c;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m555.79,154.85c0-38.93-31.85-70.79-70.79-70.79,0,0-150.74-4.21-201-4.21s-201,4.21-201,4.21c-38.93,0-70.79,31.85-70.79,70.79,0,0-4.21,88.57-4.21,118.15s4.21,118.15,4.21,118.15c0,38.93,31.85,70.79,70.79,70.79,0,0,150.74,4.21,201,4.21s201-4.21,201-4.21c38.93,0,70.79-31.85,70.79-70.79,0,0,4.21-88.5,4.21-118.15s-4.21-118.15-4.21-118.15Zm-324.66,204.46v-172.62l139.46,86.3-139.46,86.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.46f9ca2bf9963ee05a2cf5c72f8f9c2e.svg";
export { ForwardRef as ReactComponent };